export default "__VITE_ASSET__53533237__"